/**
 * @generated SignedSource<<66f78e1c9930af5c97f7d6f476466f0a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type TemplateVisibility = "GLOBAL" | "HIDDEN" | "USER" | "WORKSPACE";
import { FragmentRefs } from "relay-runtime";
export type EditTemplateMenuItem_note$data = {
  readonly id: string;
  readonly isLocked: boolean;
  readonly stream: {
    readonly id: string;
    readonly template: {
      readonly id: string;
      readonly proseDoc: any;
      readonly schemaVersion: number;
      readonly summary: string;
      readonly tags: ReadonlyArray<string>;
      readonly title: string;
      readonly viewerCanEdit: boolean;
      readonly visibility: TemplateVisibility;
    } | null;
  };
  readonly version: number;
  readonly " $fragmentSpreads": FragmentRefs<"MenuItemTooltip_useGetPropsForExternalWorkspaces_note">;
  readonly " $fragmentType": "EditTemplateMenuItem_note";
};
export type EditTemplateMenuItem_note$key = {
  readonly " $data"?: EditTemplateMenuItem_note$data;
  readonly " $fragmentSpreads": FragmentRefs<"EditTemplateMenuItem_note">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EditTemplateMenuItem_note",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "version",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isLocked",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "NoteStream",
      "kind": "LinkedField",
      "name": "stream",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "NoteTemplateNode",
          "kind": "LinkedField",
          "name": "template",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "viewerCanEdit",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "visibility",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "title",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "summary",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "proseDoc",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "schemaVersion",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "tags",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "MenuItemTooltip_useGetPropsForExternalWorkspaces_note"
    }
  ],
  "type": "Note",
  "abstractKey": null
};
})();

(node as any).hash = "99302d0d5549bc8b01ea21e417191084";

export default node;
